(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.desktopNavigationQuery = window.matchMedia('(min-width: 990px)');
      this.onHeaderResize = this.setHeaderHeight.bind(this);
      this.setHeaderHeight();

      this.desktopNavigationQuery.addEventListener('change', this.onHeaderResize);
      this.headerResizeObserver = new ResizeObserver(this.onHeaderResize);
      this.headerResizeObserver.observe(this.querySelector('.header'));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const navigation = this.querySelector('.header__inline-menu');
      this.navigationOnlySticky = Boolean(
        this.desktopNavigationQuery.matches &&
        navigation &&
        this.querySelector('.header--top-center, .header--top-left')
      );
      this.header.classList.toggle('seidler-navigation-only', this.navigationOnlySticky);

      let visibleHeight = this.header.offsetHeight;
      if (this.navigationOnlySticky) {
        this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden', 'animate');
        const headerBounds = this.header.getBoundingClientRect();
        const navigationBounds = navigation.getBoundingClientRect();
        const offset = Math.max(0, navigationBounds.top - headerBounds.top - 12);
        this.header.style.setProperty('--seidler-navigation-offset', `${offset}px`);
        visibleHeight = Math.max(0, headerBounds.height - offset);
      } else {
        this.header.style.removeProperty('--seidler-navigation-offset');
      }

      document.documentElement.style.setProperty('--header-height', `${visibleHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.desktopNavigationQuery.removeEventListener('change', this.onHeaderResize);
      this.headerResizeObserver.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.navigationOnlySticky) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  if (!customElements.get('seidler-editorial-photo')) {
    let plans = new WeakMap();

    function buildPlan(grid) {
      const source = grid.querySelector('[data-seidler-editorial-pool]');
      if (!source) return [];
      let candidates;
      try { candidates = JSON.parse(source.textContent); } catch { return []; }
      const seen = new Set();
      candidates = candidates.filter((item) => {
        if (!item.key || !item.src || !item.url || seen.has(item.key)) return false;
        seen.add(item.key);
        return true;
      });
      const count = grid.querySelectorAll('seidler-editorial-photo').length;
      const storageKey = 'seidler-editorial-v1:' + source.dataset.collectionKey;
      let previous = [];
      try {
        const stored = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
        if (Array.isArray(stored)) previous = stored;
      } catch {}
      const fresh = candidates.filter((item) => !previous.includes(item.key));
      let remaining = fresh.length >= count ? fresh : candidates.slice();
      const selected = [];
      for (let index = 0; index < count && remaining.length; index++) {
        const different = remaining.filter((item) => item.key !== previous[index]);
        const options = different.length ? different : remaining;
        const chosen = options[Math.floor(Math.random() * options.length)];
        selected.push(chosen);
        remaining = remaining.filter((item) => item.key !== chosen.key);
      }
      try { sessionStorage.setItem(storageKey, JSON.stringify(selected.map((item) => item.key))); } catch {}
      return selected;
    }

    class SeidlerEditorialPhoto extends HTMLElement {
      connectedCallback() { queueMicrotask(() => this.refresh()); }

      refresh() {
        if (!this.isConnected) return;
        const grid = this.closest('#product-grid');
        if (!grid) return;
        if (!plans.has(grid)) plans.set(grid, buildPlan(grid));
        const index = Array.from(grid.querySelectorAll('seidler-editorial-photo')).indexOf(this);
        const chosen = plans.get(grid)[index];
        if (!chosen) return;
        const link = this.querySelector('.seidler-editorial-link');
        const title = this.querySelector('[data-seidler-editorial-title]');
        const image = this.querySelector('.seidler-editorial-image');
        if (!link || !title || !image) return;
        link.href = chosen.url;
        title.textContent = chosen.title;
        image.alt = chosen.alt;
        image.width = chosen.width;
        image.height = chosen.height;
        image.srcset = chosen.srcset;
        image.src = chosen.src;
      }
    }

    customElements.define('seidler-editorial-photo', SeidlerEditorialPhoto);
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      plans = new WeakMap();
      document.querySelectorAll('seidler-editorial-photo').forEach((element) => element.refresh());
    });
  }

  } catch(e) { console.error(e); }
})();
})();
